<template>
  <el-carousel height="4.75rem">
    <el-carousel-item v-for="item in list" :key="item.imageUrl">
      <img :src="item.imageUrl" class="banner-img" />
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  props: {
    list: Array,
    default: () => [],
  },
};
</script>

<style lang="scss" scoped>
.banner-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
</style>